<template>
    <div v-if="!isLoading">
        <EditDentalIpdBill v-if="latestSale" :saleMasterId="latestSale.id" />
        <AddDentalIpdBill v-else />
    </div>
</template>
<script setup>
import AddDentalIpdBill from '@/components/molecule/company/dental-os/service/billing/AddDentalIpdBill.vue';
import EditDentalIpdBill from '@/components/molecule/company/dental-os/service/billing/EditDentalIpdBill.vue';
import handlePurchase from '@/services/modules/purchase'
import { ref } from 'vue';
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';

const {fetchLatestSaleByIpd} = handlePurchase();

const route = useRoute();
const latestSale = ref(null);
const isLoading = ref(true);

const getLatestSale = async () => {
    isLoading.value = true;
    const query = getQuery();
    await fetchLatestSaleByIpd(route.query.ipd_register_id, query).then(res => {
        if(res.data) {
            latestSale.value = res.data;
        }
    }).finally(() => {
        isLoading.value = false;
    })
}

const getQuery = () => {
    return `?company_id=${route.params.companyId}`;
}

onMounted(() => {
    getLatestSale();
})
</script>